import 'swiper/css'
import 'swiper/css/pagination'

import '../scss/style.scss'

import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

console.log('It works!')

// ======================
// меню
// ======================

const openBtn = document.querySelector('.burger')
const aside = document.querySelector('.aside__menu')
const closeBtn = document.querySelector('.aside__close')

if (openBtn && aside) {
  openBtn.addEventListener('click', () => {
    aside.classList.add('aside__menu--active')
  })
}

if (closeBtn && aside) {
  closeBtn.addEventListener('click', () => {
    aside.classList.remove('aside__menu--active')
  })
}

// ======================
// swiper
// ======================

let swipers = []

function initSwipers() {
  // мобильный swiper
  if (window.innerWidth < 768) {
    // чтобы не создавать swiper повторно
    if (swipers.length === 0) {
      document.querySelectorAll('.swiper').forEach((el) => {
        const swiper = new Swiper(el, {
          modules: [Pagination],

          slidesPerView: 'auto',
          spaceBetween: 16,

          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        })

        swipers.push(swiper)
      })
    }
  }

  // desktop
  else {
    // уничтожить swiper
    swipers.forEach((swiper) => {
      swiper.destroy(true, true)
    })

    swipers = []

    // удалить inline стили swiper-wrapper
    document.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
      wrapper.removeAttribute('style')
    })

    // удалить inline стили swiper-slide
    document.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.removeAttribute('style')
    })
  }
}

// ======================
// показать / скрыть
// ======================

function initToggleBlocks() {
  document.querySelectorAll('.toggle-block').forEach((block) => {
    const showBtn = block.querySelector('.showBtn')
    const hideBtn = block.querySelector('.hideBtn')
    const items = block.querySelectorAll('.hidden-item, .text-open')

    if (!showBtn || !hideBtn || items.length === 0) {
      return
    }

    // показать
    showBtn.addEventListener('click', () => {
      items.forEach((item) => {
        item.classList.add('show-all')
      })

      showBtn.classList.add('hidden')
      hideBtn.classList.remove('hidden')
    })

    // скрыть
    hideBtn.addEventListener('click', () => {
      items.forEach((item) => {
        item.classList.remove('show-all')
      })

      hideBtn.classList.add('hidden')
      showBtn.classList.remove('hidden')
    })
  })
}

// ======================
// запуск
// ======================

initSwipers()

window.addEventListener('resize', initSwipers)

initToggleBlocks()